// Copyright (c) 2017 Deere & Company

import './index.scss';
import React, {PropTypes} from 'react';
import {
    filterCollection,
    sortCollection
} from '../../../../shared/services/collections';
import {
    getFilterOptions,
    getSortOptions
} from '../../../shared/services/product-search-helper';
import InlineAlertBar from '../../../../shared/components/inline-alert-bar';
import ProductList from '../../../search/components/product-list';
import ProductSearchResult from '@deere/cps-it.warranty-model-factory/lib/product-search-results';
import RefinableListWidget from '../../../../shared/components/refinable-list-widget';
import SearchFilters from '../../../shared/state/search-filters';
import TabNavigation from '../../../../shared/components/tab-navigation';
import {getTab} from '../../services/tab';

function openCreateClaimModal(pin) {

    this.updateCreateClaimModalVisibility(true, pin);

}

function handleOpenStatusChangeModal(product) {

    this.updateProduct(product);

}

function handleFilterByChange(filter) {

    this.onUpdateSearchFilters('filterBy', filter);

}

function handleSortByChange(sortBy) {

    this.onUpdateSearchFilters('sortBy', sortBy);

}

function handleSortDirectionChange(sortDirection) {

    this.onUpdateSearchFilters('sortDirection', sortDirection);

}

const ProductsList = props => {

    let sortedCollection;

    sortedCollection = [...props.products];
    sortedCollection = sortCollection(props.searchFilters.sortBy, props.searchFilters.sortDirection, sortedCollection);
    sortedCollection = filterCollection(props.searchFilters.filterBy, getFilterOptions(), sortedCollection);

    return (
        <div className='products-list'>
            <div className='header'>
                <TabNavigation
                    tabs={getTab(props.products.length)}
                />

            </div>
            {props.partialData &&
                <InlineAlertBar
                    label='PRODUCTS_BY_CUSTOMER_PARTIAL_DATA_WARNING'
                    type='warning'
                />
            }
            <ProductList
                onClaimsModalOpen={props::openCreateClaimModal}
                onOpenStatusChangeModal={props::handleOpenStatusChangeModal}
                products={sortedCollection}
            >
                <RefinableListWidget
                    onFilterByChange={props::handleFilterByChange}
                    onSortByChange={props::handleSortByChange}
                    onSortDirectionChange={props::handleSortDirectionChange}
                    searchFilters={props.searchFilters}
                    sortOptions={getSortOptions()}
                />
            </ProductList>
        </div>
    );

};

ProductsList.displayName = 'ProductsList';
ProductsList.propTypes = {
    ckcId: PropTypes.string.isRequired,
    onUpdateSearchFilters: PropTypes.func.isRequired,
    partialData: PropTypes.bool.isRequired,
    products: PropTypes.arrayOf(PropTypes.instanceOf(ProductSearchResult)).isRequired,
    searchFilters: PropTypes.instanceOf(SearchFilters).isRequired,
    updateCreateClaimModalVisibility: PropTypes.func.isRequired,
    updateProduct: PropTypes.func.isRequired,
    updateStatusChangeModalVisibility: PropTypes.func.isRequired,
    userLanguage: PropTypes.string.isRequired
};

export default ProductsList;



// WEBPACK FOOTER //
// ./src/product/products-by-customer/components/products-list/index.js